<template>
    <span class="flex ai:center gap:8 cursor:pointer color:#5E6472 color:primary:hover" @click="copy">
        <i class="fa-regular fa-share-from-square" :class="`f:${size}`"></i>
        <slot></slot>
    </span>
    <Teleport to="body">
        <div ref="modal" tabindex="-1" class="
            modal
            fade
            {max-w:1280}_.modal-dialog@xl
            {max-w:700}_.modal-dialog@sm
            {max-w:400}_.modal-dialog@<sm
            {box-shadow:0|0|20|0|black/.1}_.modal-content
            {r:12;b:1|solid|#FFE58F;p:24;background:#FFFCEF}_.modal-body
        ">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="font-weight:400 f:18 lh:28.8px color:rgba(0,0,0,0.85) flex flex:nowrap lines:1">
                            <i class="fa-solid fa-copy color:#fea84c mr:10 f:28 text:center"></i>
                            <span v-if="title">已複製連結：{{ title }} https://www.1111opt.com.tw</span>
                            <span v-else>已複製連結：https://www.1111opt.com.tw/link/{{ path }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const props = defineProps({
        path: { required: true, type: String },
        size: { default: 16, type: Number },
        title: { type: String }
    });

    const modal = ref();

    const copy = () => {
        navigator.clipboard.writeText(`https://www.1111opt.com.tw/link/${props.path}?openExternalBrowser=1`).then(() => {
            $(modal.value).modal('show');

            setTimeout(() => $(modal.value).modal('hide'), 3000);
        });
    };
</script>
